import { ILocale } from "../../@contexts/locale/conf";
import { faIR, enUS } from "@mui/material/locale";
import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import EN from "@commons/locales/En.json";
import FA from "@commons/locales/Fa.json";

const Locales: ILocale[] = [
  {
    key: "en-US",
    language: "English",
    short: "En",
    direction: "ltr",
    muiLocale: enUS,
  },
  {
    key: "fa-IR",
    language: "Persian",
    short: "Fa",
    direction: "rtl",
    muiLocale: faIR,
  },
];

const options = {
  // order and from where user language should be detected
  order: ["querystring", "localStorage"],
  lookupQuerystring: "lng",
  lookupLocalStorage: "i18nextLng",
  caches: ["localStorage"],
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    detection: options,
    resources: {
      en: {
        translation: EN,
      },
      fa: {
        translation: FA,
      },
    },
    fallbackLng: "fa-IR",
  });

i18n.changeLanguage();
export { Locales, i18n };
